export class LoginAction {
  static readonly type = '[Auth] Login';
  constructor(public payload: { user: any, pass: any, returnUrl:any, remember:any }) {}
}
export class LogoutAction {
  static readonly type = '[Auth] Logout';
}
export class VerifyAccountAction {
  static readonly type = '[Auth] VerifyAccountAction';
  constructor(public payload:{
    code: string
  }) {}
}
export class ResendVerificationCodeAction {
  static readonly type = '[Auth] ResendVerificationCodeAction';
}
